import { initMlvAnalytics, mlvAnalyticsSetUser, mlvAnalyticsSetUserProps } from './mlvAnalytics.js';
import { initMlvClarity, mlvClaritySetUser } from './mlvClarity.js';
import { initMlvSentry, mlvSentrySetUser, mlvSentryCaptureException } from './mlvSentry.js';

/**
 * Inicializa todos los proveedores de telemetría leyendo variables Vite.
 * Idempotente: llamar una sola vez en el arranque.
 *
 * Env vars:
 *  - VITE_FIREBASE_MEASUREMENT_ID → GA4 (requiere init de Firebase App previo).
 *  - VITE_CLARITY_PROJECT_ID      → Microsoft Clarity.
 *  - VITE_SENTRY_LOADER_KEY       → Sentry Loader Script (hash entre /.../min.js).
 *  - VITE_APP_VERSION             → release tag (usado por Sentry).
 *  - VITE_MLV_TELEMETRY_DISABLE   → 'true' apaga todo (útil en staging).
 */
export function initMlvTelemetry() {
  const env = import.meta.env || {};
  if (String(env.VITE_MLV_TELEMETRY_DISABLE || '').toLowerCase() === 'true') return;

  const environment = env.DEV ? 'development' : 'production';
  const release = env.VITE_APP_VERSION || undefined;

  initMlvAnalytics({ measurementId: env.VITE_FIREBASE_MEASUREMENT_ID });
  initMlvClarity({ projectId: env.VITE_CLARITY_PROJECT_ID });
  initMlvSentry({ loaderKey: env.VITE_SENTRY_LOADER_KEY, environment, release });

  if (typeof window !== 'undefined') {
    window.addEventListener('error', (e) => {
      try {
        mlvSentryCaptureException(e.error || new Error(e.message || 'window.error'), {
          filename: e.filename,
          lineno: e.lineno,
          colno: e.colno,
        });
      } catch (_e) {
        /* ignore */
      }
    });
    window.addEventListener('unhandledrejection', (e) => {
      try {
        const reason = e.reason instanceof Error ? e.reason : new Error(String(e.reason));
        mlvSentryCaptureException(reason, { kind: 'unhandledrejection' });
      } catch (_e) {
        /* ignore */
      }
    });
  }
}

/** Propaga la identidad del usuario a los tres proveedores. */
export function setMlvTelemetryUser(uid, props = {}) {
  mlvAnalyticsSetUser(uid);
  mlvClaritySetUser(uid);
  mlvSentrySetUser(uid);
  if (uid && props && Object.keys(props).length) {
    mlvAnalyticsSetUserProps(props);
  }
}
